import moment from "moment";
import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import nextQues from "../../helper/nextQues";
import submitQues from "../../helper/submitQues";
import { arrayValidation } from "../../helper/validation";
import { AnswerContext } from "../../store/answerStore";
import { HelperContext } from "../../store/helperStore";
import TestFooter from "../testFooter/testFooter";
import "./shuffleSentence.scss";

export default function ShuffleSentence({ question, questions, index }) {
  const { answerC, dispatchAnswer } = AnswerContext();
  const { helperC, dispatchHelper } = HelperContext();
  const [startTime, setStartTime] = useState();
  const { isNextQues } = helperC;
  const [userAns, setUserAns] = useState([]);

  console.log("userAns", userAns);

  let queTitle = question.que_title1;
  queTitle = queTitle.split("/");
  queTitle = queTitle.map((queTitle) => queTitle.trim());

  useEffect(() => {
    setStartTime(moment());
  }, []);

  const getTimeSpend = () => {
    return moment().diff(startTime);
  };

  const handleWord = (word, index) => {
    if (userAns.some((ans) => ans.index === index)) {
      // if element is already selected
      const ans = userAns.filter((ans) => ans.index !== index);
      setUserAns(ans);
    } else if (queTitle.length > userAns.length + 1) {
      setUserAns((prevAns) => [...prevAns, { word, index }]);
    }
  };

  const queClass = (index) => {
    if (userAns.some((ans) => ans.index === index)) {
      return "shuffle-word selected";
    } else {
      return "shuffle-word";
    }
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      userAns,
      result.source.index,
      result.destination.index
    );

    setUserAns(items);
  };

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    margin: "4px",
    borderRadius: "6px",
    padding: "8px 10px",
    boxShadow: "0 0 4px 0px #949494",
    userSelect: "none",
    fontWeight: "600",
    color: "#fff",
    // change background colour if dragging
    background: isDragging ? "#d3d3d3" : "#2b72fe",
    display: "inline-flex",
    // border: '1px solid grey',

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    // background: isDraggingOver ? 'lightblue' : 'lightgrey',
    display: "flex",
    padding: 8,
    overflow: "auto",
  });

  useEffect(() => {
    if (isNextQues) {
      index < questions.length - 1 ? handleNext() : handleSubmit();
      dispatchHelper({ type: "IS_NEXT_QUES", payload: false });
    }
  }, [isNextQues]);

  const getAns = () => {
    const answer = userAns.map(function (item) {
      return item["word"];
    });
    return answer.join(" ");
  };

  const handleNext = () => {
    const nextQuesId = questions[index + 1].id;
    nextQues(
      dispatchAnswer,
      dispatchHelper,
      nextQuesId,
      getAns(),
      getTimeSpend(),
      question
    );
  };

  const handleSubmit = () => {
    submitQues(
      dispatchAnswer,
      dispatchHelper,
      getAns(),
      getTimeSpend(),
      question,
      answerC.answers,
      null, // answerAudio
      null, // testFormat
      questions,
      helperC.testType
    );
  };

  const handleAnsWord = (ansData) => {
    const ans = userAns.filter((ans) => ans.index !== ansData.index);
    setUserAns(ans);
  };

  return (
    <>
      <div className="test-body-content">
        <p data-aos="zoom-in" className="shuffle-inst">
          Rearrange the word below to make a meaningful sentence.
          <br />
          Ignore one word that does not belong
        </p>
        <div data-aos="zoom-in" className="shuffle-words">
          {queTitle &&
            queTitle.map((shuffleData, index) => {
              return (
                <div
                  className={queClass(index)}
                  key={index}
                  onClick={() => handleWord(shuffleData, index)}
                >
                  <h3>{shuffleData}</h3>
                </div>
              );
            })}
        </div>

        <div className="shuffled-words">
          <DragDropContext onDragEnd={onDragEnd} className="droppable">
            <Droppable droppableId="droppable" direction="horizontal">
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                  {...provided.droppableProps}
                >
                  {userAns.map((item, index) => (
                    <Draggable
                      key={item.index.toString()}
                      draggableId={item.index.toString()}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                          onClick={() => handleAnsWord(item)}
                        >
                          <div {...provided.dragHandleProps}>{item.word}</div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>

      <TestFooter
        isUserInput={arrayValidation(userAns)}
        question={question}
        questions={questions}
        index={index}
      />
    </>
  );
}
